module.exports = __webpack_public_path__ + "img/default_bg.ab8f21ba.png";